import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { ROUTES } from 'constants/RoutePaths';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { signInWithRedirect, decodeJWT, signOut } from 'aws-amplify/auth';
import { isUserAuth, userToken } from '_actions/user_actions';
import { setUserEmail, setUserId } from 'app/state';

import { useGetUserDetailsQuery } from 'app/api/usersApiSlice';
import useAuth from 'hooks/useAuth';

export default function TSNavBar() {
  const dispatch = useDispatch();
  const { isAdmin, isSafetyMonitor } = useAuth();

  const userEmail = useSelector((state) => state.global?.userEmail);
  const [anchorEl1, setAnchorEl1] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);

  const [isAuth, setIsAuth] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const t = await userToken();
      const decodedToken = t ? decodeJWT(t.toString()).payload : null;
      setIsAuth(!!t);
      dispatch(setUserEmail(decodedToken?.email));
    };
    checkAuth();
    setIsLoading(false);
  }, []);

  const { data: userData, isLoading: isUserLoading } = useGetUserDetailsQuery(
    userEmail,
    { skip: !userEmail }
  );

  useEffect(() => {
    if (userData) {
      console.log('userData First: ', userData);
      dispatch(setUserId(userData?.[0]?.user_id));
    } else if (!isUserLoading) {
      console.log('No user data found for email: ', userEmail);
    }
  }, [userData]);

  const handleSignIn = () => {
    const path = location.pathname + location.search;
    localStorage.setItem('postSignInPath', path);
    signInWithRedirect();
  };

  const handleSignOut = async () => {
    try {
      await signOut();
      console.log('User signed out successfully');
      setIsAuth(false);
      // You can add logic here to redirect the user or update UI state
      navigate('/');
    } catch (error) {
      console.log('error signing out: ', error);
    }
  };

  const handleNavigate = (route) => {
    setAnchorEl1(null);
    setAnchorEl2(null);
    navigate(route);
  };

  const handleAcctMenu = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleMenu = (event) => {
    setAnchorEl1(event.currentTarget);
  };

  const handleCloseAcctMenu = () => {
    setAnchorEl2(null);
  };
  const handleCloseMenu = () => {
    setAnchorEl1(null);
  };

  if (isLoading || isUserLoading) {
    return <div>Loading...</div>;
  } else {
    return (
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" elevation={0} sx={{ bgcolor: 'transparent' }}>
          <Toolbar>
            <div className="flex items-center w-full bg-[var(--ts-primary)] rounded-2xl px-3 py-1 my-2">
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                aria-haspopup="true"
                onClick={(e) => handleMenu(e)}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl1}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorEl1)}
                onClose={handleCloseMenu}
              >
                <MenuItem onClick={() => handleNavigate(`/${ROUTES.HOME}`)}>
                  Home
                </MenuItem>
                <MenuItem
                  onClick={() => handleNavigate(`/${ROUTES.TRAIL_HOME}`)}
                >
                  Trails Home
                </MenuItem>
                {(isAdmin || isSafetyMonitor) && (
                  <MenuItem
                    onClick={() => handleNavigate(`/${ROUTES.LIVE_ACTIVITIES}`)}
                  >
                    Live Activities
                  </MenuItem>
                )}
                {isAdmin && (
                  <MenuItem
                    onClick={() =>
                      handleNavigate(`/${ROUTES.ADMIN_WELFARE_CHECK_SETTINGS}`)
                    }
                  >
                    Welfare Check Settings
                  </MenuItem>
                )}
              </Menu>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                TrailSafe
              </Typography>
              {isAuth ? (
                <>
                  <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleAcctMenu}
                    color="inherit"
                  >
                    <AccountCircle />
                  </IconButton>
                  <Menu
                    id="acct-menu-appbar"
                    anchorEl={anchorEl2}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    open={Boolean(anchorEl2)}
                    onClose={handleCloseAcctMenu}
                  >
                    <MenuItem
                      onClick={() => handleNavigate(`/${ROUTES.PROFILE}`)}
                    >
                      Profile
                    </MenuItem>
                    <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
                  </Menu>
                </>
              ) : (
                <div>
                  <Button color="inherit" onClick={handleSignIn}>
                    Sign In
                  </Button>
                </div>
              )}
            </div>
          </Toolbar>
        </AppBar>
      </Box>
    );
  }
}
